var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOffline)?_c('div',{staticClass:"offline-container"},[_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"width":"200","srcset":require('@/assets/img/offline.png')}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('目前没有网路'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t('无法使用耶'))+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }